import { FETCH_PARTNER_ASSIGNMENTS, UPDATE_PARTNER_ASSIGNMENTS, FETCH_EMAIL_ASSIGNMENTS } from '../actionTypes';

const initialState = {
  partner: {},
  emails: {}
};

export default function(state = initialState, action=null){
  switch (action.type) {
    case UPDATE_PARTNER_ASSIGNMENTS:
      if (action.payload) {
        return {
          ...state,
          partner: {
            ...action.payload
          }
        }
      }
      return state;
    case FETCH_PARTNER_ASSIGNMENTS:
      if (action.payload) {
        return {
          ...state,
          partner: action.payload
        }
      }
      return state;
    case FETCH_EMAIL_ASSIGNMENTS:
      return {
        ...state,
        emails: {
          ...action.payload
        }
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/assignments.js